import React from 'react'
import { compose, withState } from 'recompose'
import styled from 'styled-components'
import { Button, Transition } from 'semantic-ui-react'

const Dot = styled.span`
  ${({ enlarge }) => ({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: '#000000',
  transition: '0.3s',
  display: 'inline-block',
  position: 'absolute',
  left: '50%',
  marginLeft: '-5px',
  top: '-4px',
  zIndex: '1000',
  transform: `scale(${enlarge ? '3' : '1'})`,
  ':hover': {
    cursor: 'pointer',
  },
})}
`

const Wrapper = styled.div`
  ${({ enlarge }) => ({
  position: 'absolute',
  height: enlarge ? '3px' : 0,
  transition: '0.3s',
  width: '100%',
  zIndex: '1000',
  backgroundColor: enlarge ? '#000000' : 'transparent',
})}
`

const EnlargeButton = compose(
  withState('isOver', 'setIsOver', false)
)(
  ({
    isActive,
    isOver,
    setIsOver,
    onClick,
  }) => {
    return (
      <Wrapper
        enlarge={isOver || isActive}
      >
        <Dot
          enlarge={isOver || isActive}
          onMouseEnter={() => setIsOver(true)}
        />
        <Transition visible={isOver} duration={300}>
          <Button
            icon="plus"
            circular
            style={{
              position: 'absolute',
              left: '50%',
              marginLeft: '-18px',
              marginTop: '-17px',
              zIndex: 1001,
            }}
            onClick={onClick}
            onMouseLeave={() => setIsOver(false)}
          />
        </Transition>
      </Wrapper>
    )
  }
)

EnlargeButton.propTypes = {}
EnlargeButton.defaultProps = {}

export default EnlargeButton



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/components/EnlargeButton.js